import { Boundary, BoundaryWithSoftBoundary } from '@/types';

export const getHasSoftBoundary = (
  boundary: Boundary | BoundaryWithSoftBoundary
): boundary is BoundaryWithSoftBoundary => Boolean(boundary.soft.content);

// strange, but necessary for typescript because structurally both types are the same
// this creates the issue that the type of the else case is not the other type but `never`
export const getHasNoSoftBoundary = (
  boundary: Boundary | BoundaryWithSoftBoundary
): boundary is Boundary => !getHasSoftBoundary(boundary);
